(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-custom"] && !Shopify.designMode) return;
  try {
    
  class NewsletterForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('.footer-custom__newsletter-input');
      this.successEl = this.querySelector('.footer-custom__newsletter-status--success');
      this.errorEl = this.querySelector('.footer-custom__newsletter-status--error');
      if (!this.form) return;

      // Initial state derived from Liquid-rendered DOM (post-reload truth).
      const hasSuccess = this.successEl && !this.successEl.hasAttribute('hidden');
      const hasError = this.errorEl && !this.errorEl.hasAttribute('hidden');
      if (hasSuccess) {
        this.setState('success');
      } else if (hasError) {
        this.setState('error');
      } else {
        this.setState('idle');
      }

      this.form.addEventListener('submit', () => {
        // Do not preventDefault — Shopify customer form POSTs and reloads.
        if (this.input) this.input.setAttribute('readonly', '');
        this.setState('submitting');
      });
    }

    setState(state) {
      this.setAttribute('data-state', state);
    }
  }

  if (!customElements.get('newsletter-form')) {
    customElements.define('newsletter-form', NewsletterForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
